module.exports = __webpack_public_path__ + "img/icon-request-buy.c71a4b6e.svg";